import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "./style";
import * as env from "shared/env";

interface Props extends WithStyles<typeof styles> {
	children?: React.ReactNode;
	className?: string;
}

const Component = ({ classes = {}, children, className }: Props) => (
	<Mui.Card
		elevation={0}
		className={[classes.card, className].filter(Boolean).join(" ")}
	>
		{children}
	</Mui.Card>
);

export const AppCard = withStyles(Component, styles);
